// src/api/ApiClient.js
import { fetchConfig } from '../config/configService';

function isValidUrl(url) {  
  if (!url || typeof url !== 'string') return false;
  
  try {
    const parsedUrl = new URL(url);
    
    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
  } catch {
    return false;
  }
}

function ensureTrailingSlash(url) {
  // console.log('ensureTrailingSlash Url', url);

  if (!url) return url;
  return url.endsWith('/') ? url : url + '/';
}

const createApiClient = async () => {
  const config = await fetchConfig();
  
  const storedUrl = localStorage.getItem("mobileApiUrl");
  
  // console.log('Stored mobileApiUrl from localStorage:', storedUrl);
  // console.log('Config apiBaseUrl:', config?.apiBaseUrl);
  
  const mobileApiUrl = isValidUrl(storedUrl) ? storedUrl : config?.apiBaseUrl;
  const accountMgtApiUrl = config?.accountMgtApiUrl;

  console.log('final mobile url', ensureTrailingSlash(mobileApiUrl),);
  console.log('final acc url', ensureTrailingSlash(accountMgtApiUrl),);
  
  return {
    mobileApiUrl: ensureTrailingSlash(mobileApiUrl),
    accountMgtApiUrl: ensureTrailingSlash(accountMgtApiUrl)
  };
};

export default createApiClient;